module.exports = __webpack_public_path__ + "img/rainoil_1a.14446bb7.jpg";